import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const TagBase = ({ pretext, children, ...rest }) => (
  <li {...rest}>
    {pretext}
    {children}
  </li>
)

TagBase.propTypes = {
  pretext: PropTypes.node,
  children: PropTypes.node,
}

TagBase.defaultProps = {
  pretext: null,
  children: null,
}

const TagNormal = styled(TagBase)`
  cursor: pointer;
  padding: 2px 0.5%;
  margin-right: 10px;
  margin-bottom: 1px;
  color: #b9c5cd;
  list-style-type: none;
  display: inline-block;
`

const TagActive = styled(TagBase)`
  cursor: pointer;
  padding: 1px 1.33%;
  margin-right: 10px;
  margin-bottom: 1px;
  border: 1px solid #b9c5cd;
  border-radius: 8px;
  list-style-type: none;
  background-color: #fff;
  display: inline-block;
`

const TagUpdating = styled(TagBase)`
  cursor: wait;
  padding: 1px 0.5%;
  margin-right: 10px;
  margin-bottom: 1px;
  color: #b9c5cd;
  list-style-type: none;
  display: inline-block;
  opacity: 0.3;
`

const TagView = styled(TagBase)`
  font-size: 10px;
  padding: 6px 10px 4px 10px;
  margin-right: 10px;
  border: 1px solid #b9c5cd;
  border-radius: 8px;
  color: #b9c5cd;
  liststyletype: none;
  backgroundcolor: #fff;
  display: inline-block;
`

const Tag = ({ active, updating, view, ...rest }) => {
  if (updating) {
    return <TagUpdating {...rest} />
  }
  if (active) {
    return <TagActive {...rest} />
  }
  if (view) {
    return <TagView {...rest} />
  }
  return <TagNormal {...rest} />
}

Tag.propTypes = {
  active: PropTypes.bool,
  updating: PropTypes.bool,
  view: PropTypes.bool,
}

Tag.defaultProps = {
  active: false,
  updating: false,
  view: false,
}

export default Tag
